import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ChartTitle } from "../styles/employer-analytics-styles";
import {
  Wrapper,
  Charts,
  Column,
  ColumnTitle,
  ColumnData,
} from "../styles/time-to-submission-styles";

export interface ITimeToSubmissionProps {
  yourPsl: number;
  marketplaceAgencies: number;
  pdfExport?: boolean;
}

export const TimeToSubmission: FunctionComponent<ITimeToSubmissionProps> = ({
  yourPsl,
  marketplaceAgencies,
  pdfExport,
}) => (
  <Wrapper className="animated fadeIn" pdfExport={pdfExport}>
    <ChartTitle marginBottom={5} data-test-id="time-to-submission-charts-title">
      Time To Submission
    </ChartTitle>
    <Charts data-test-id="time-to-submission-charts" pdfExport={pdfExport}>
      <Column data-test-id="your-psl-tts">
        <ColumnData data-test-id="average-hours-from-psl">
          {yourPsl}
          <br />
          hours
        </ColumnData>
        <ColumnTitle>Your PSL</ColumnTitle>
      </Column>
      <Column data-test-id="marketplace-agencies-tts">
        <ColumnData data-test-id="average-hours-from-marketplace">
          {marketplaceAgencies}
          <br />
          hours
        </ColumnData>
        <ColumnTitle>Marketplace agencies</ColumnTitle>
      </Column>
    </Charts>
  </Wrapper>
);

TimeToSubmission.propTypes = {
  yourPsl: PropTypes.number,
  marketplaceAgencies: PropTypes.number,
  pdfExport: PropTypes.bool,
};

TimeToSubmission.defaultProps = {
  yourPsl: 0,
  marketplaceAgencies: 0,
  pdfExport: false,
};

interface IReduxState {
  employerAnalytics: {
    agencyPerformanceData: {
      timeToSubmission: {
        averageHoursFromPsl: number;
        averageHoursFromMarketplace: number;
      };
    };
  };
}

const mapStateToProps = (state: IReduxState) => ({
  yourPsl:
    state.employerAnalytics.agencyPerformanceData.timeToSubmission
      .averageHoursFromPsl,
  marketplaceAgencies:
    state.employerAnalytics.agencyPerformanceData.timeToSubmission
      .averageHoursFromMarketplace,
});

export default connect(mapStateToProps, {})(TimeToSubmission);
